<template>
  <div class="banner" :class="`banner--${computedVariant}`">
    <div class="banner__text">
      <span v-html="textHTML" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    showResponse: {
      type: Object,
      default: () => {},
    },
    errorResponse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      variantMappings: {
        Aktif: 'success',
        'Tidak Aktif': 'warning',
        'Gagal Dijalankan': 'error',
      },

      errorCodeMapping: {
        ERR_EXPIRED_SCHEDULER: `<span>Penjadwalan sudah melewati tanggal berakhir perulangan. Perbarui perulangan dan aktifkan jika ingin penjadwalan dijalankan kembali.</span>`,
        ERR_INVALID_TEMPLATE: `<span>Penjadwalan gagal dijalankan karena ada kesalahan pada template. Perbaiki template dan aktifkan kembali penjadwalan.</span>`,
        ERR_EMPTY_TEMPLATE: `<span>Penjadwalan gagal dijalankan karena ada kesalahan pada template. Perbaiki template dan aktifkan kembali penjadwalan.</span>`,
        ERR_UNEXPECTED_SYSTEM: `<span>Penjadwalan gagal dijalankan karena ada kesalahan pada server.  Mohon menunggu, saat ini penjadwalan sedang dijalankan kembali secara otomatis.</span>`,
        ERR_INACTIVE_PURPOSE: `<span>Penjadwalan berhenti dijalankan. Aktifkan jika ingin penjadwalan dijalankan kembali.</span>`,
      },
    }
  },
  computed: {
    status() {
      return this.showResponse?.status
    },
    textHTML() {
      let message = `<span>Penjadwalan berhenti dijalankan. Aktifkan jika ingin penjadwalan dijalankan kembali.</span>`
      if (this.status.name === 'Aktif') {
        let nextRun = '-'
        if (this.showResponse.next_run !== null) {
          nextRun = moment(this.showResponse.next_run).format('dddd, DD MMMM YYYY')
        }

        message = `<span>Jadwal selanjutnya adalah <strong>${nextRun}</strong></span>`
      }

      if (this.errorResponse?.code?.length > 0) {
        message = this.errorCodeMapping[this.errorResponse.code[0]]
      }

      return message
    },
    computedVariant() {
      if (this.errorResponse?.code?.length > 0) {
        if (this.errorResponse.code.includes('ERR_INACTIVE_PURPOSE')) {
          return 'warning'
        }

        return 'error'
      }

      return this.variantMappings[this.status.name]
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 72px;
  font-size: 13px;
  padding: 0px 20px;
  margin-top: -24px;

  display: flex;
  align-items: center;
  gap: 40px;

  &__text {
    height: fit-content;
  }

  &--success {
    background-color: $green-100;
  }

  &--warning {
    background-color: $yellow-100;
  }

  &--error {
    background-color: #fee8e5;
  }
}
</style>
